import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-2" }, null, -1)
const _hoisted_3 = { class: "cell-item" }
const _hoisted_4 = { class: "cell-item" }
const _hoisted_5 = { class: "cell-item" }
const _hoisted_6 = { class: "cell-item" }
const _hoisted_7 = { class: "cell-item" }
const _hoisted_8 = { class: "cell-item" }
const _hoisted_9 = { class: "cell-item" }
const _hoisted_10 = { class: "cell-item" }
const _hoisted_11 = { class: "cell-item" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Rebate Target Accounts", -1)
const _hoisted_14 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_15 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "UID", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", null, "Target Wallet ID", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "Released On", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Check Rebate Data", -1)
const _hoisted_24 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_25 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "UID", -1)
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 2,
  class: "fw-semibold text-black"
}

import { ref, computed, inject } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import RebateService from "@/projects/tenant/modules/rebate/services/RebateService";
import moment from "moment";
import TimeShow from "@/components/TimeShow.vue";
import UserInfo from "@/components/UserInfo.vue";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import BalanceShow from "@/components/BalanceShow.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Search, Promotion } from "@element-plus/icons-vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import { ElNotification } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'TradeRebateDetailModal',
  setup(__props, { expose: __expose }) {

const isLoading = ref(true);
const checkLoading = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const item = ref<any>({});
const check = ref(false);
const resendShow = ref(false);
const services = ref<any>(null);
const checkData = ref<any>({});
const platformName = computed(
  () =>
    services.value?.find((s: any) => s.id === item.value.tradeServiceId)
      ?.name ?? ""
);
const show = async (_item: any) => {
  modalRef.value?.show();
  try {
    isLoading.value = true;
    item.value = await RebateService.getTradeRebateDetails(_item.id);
    if (services.value === null) {
      services.value = await AccountService.getServices();
    }
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};
const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);

const reset = async () => {
  openConfirmModal?.(() => RebateService.resendRebate(item.value.id));
};
const showCheck = async () => {
  check.value = true;

  try {
    checkLoading.value = true;
    checkData.value = await RebateService.getRebateCheck(item.value.id);
    resendShow.value = true;
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    checkLoading.value = false;
  }
};
const handleBeforeClose = () => {
  check.value = false;
  resendShow.value = false;
  checkData.value = {};
};

__expose({
  show,
  hide: () => modalRef.value?.hide(),
});

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.tradeRebateDetails'),
    "is-loading": isLoading.value,
    width: 1000,
    "before-close": handleBeforeClose,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingCentralBox, { key: 0 }))
        : _createCommentVNode("", true),
      (!isLoading.value && item.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_descriptions, {
              class: "margin-top",
              title: _ctx.$t('title.trade'),
              column: 3,
              border: ""
            }, {
              extra: _withCtx(() => [
                _hoisted_2,
                _createVNode(UserInfo, {
                  user: item.value?.sourceTradeAccount?.user,
                  "disable-comment-view": ""
                }, null, 8, ["user"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("fields.accountNo")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(item.value?.sourceTradeAccount?.accountNumber), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("fields.ticket")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(item.value.ticket), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("fields.platform")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(platformName.value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("fields.symbol")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(item.value.symbol), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("fields.currency")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`type.currency.${item.value.currencyId}`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("fields.volume")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(item.value.volume / 100), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("fields.currentStatus")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`type.tradeRebateStatus.${item.value.status}`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("fields.openTime")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(TimeShow, {
                      type: "exactTime",
                      "date-iso-string": item.value.openedOn
                    }, null, 8, ["date-iso-string"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("fields.closeTime")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(TimeShow, {
                      type: "exactTime",
                      "date-iso-string": item.value.closedOn
                    }, null, 8, ["date-iso-string"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_el_divider),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  class: "me-2",
                  icon: _unref(Search),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showCheck()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.check")), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                (resendShow.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "success",
                      plain: "",
                      class: "me-5",
                      icon: _unref(Promotion),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (reset()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Resend")
                      ]),
                      _: 1
                    }, 8, ["icon"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_14, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_15, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
                    _hoisted_16,
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.group")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.amount")), 1),
                    _hoisted_17,
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.postedOn")), 1),
                    _hoisted_18
                  ])
                ]),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                      _createVNode(_component_LoadingRing)
                    ]))
                  : (!isLoading.value && item.value.rebates.length === 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                        _createVNode(_component_NoDataBox)
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.rebates, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, [
                              _createVNode(UserInfo, {
                                user: item.user,
                                "disable-comment-view": ""
                              }, null, 8, ["user"])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.targetAccount.uid), 1),
                            _createElementVNode("td", null, _toDisplayString(item.targetAccount.group), 1),
                            _createElementVNode("td", null, [
                              _createVNode(BalanceShow, {
                                balance: item.amount,
                                "currency-id": item.currencyId
                              }, null, 8, ["balance", "currency-id"])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.targetWalletId), 1),
                            _createElementVNode("td", null, [
                              _createVNode(TimeShow, {
                                type: "exactTime",
                                "date-iso-string": item.postedOn
                              }, null, 8, ["date-iso-string"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(TimeShow, {
                                type: "exactTime",
                                "date-iso-string": item.releasedOn
                              }, null, 8, ["date-iso-string"])
                            ])
                          ]))
                        }), 128))
                      ]))
              ])
            ]),
            (check.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_el_divider),
                  _hoisted_23,
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_24, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_25, [
                          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("fields.user")), 1),
                          _hoisted_27,
                          _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t("fields.group")), 1),
                          _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t("fields.amount")), 1),
                          _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t("fields.postedOn")), 1)
                        ])
                      ]),
                      (checkLoading.value)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_31, [
                            _createVNode(_component_LoadingRing)
                          ]))
                        : (!checkLoading.value && checkData.value.length === 0)
                          ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                              _createVNode(_component_NoDataBox)
                            ]))
                          : (_openBlock(), _createElementBlock("tbody", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkData.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, [
                                    _createVNode(UserInfo, {
                                      user: item.user,
                                      "disable-comment-view": ""
                                    }, null, 8, ["user"])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(item.targetAccount.uid), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.targetAccount.group), 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(BalanceShow, {
                                      balance: item.amount,
                                      "currency-id": item.currencyId
                                    }, null, 8, ["balance", "currency-id"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(TimeShow, {
                                      type: "exactTime",
                                      "date-iso-string": item.postedOn
                                    }, null, 8, ["date-iso-string"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})